<template>
  <nav
    v-if="pages > 1"
    class="clearfix"
    aria-label="Page navigation">
    <ul class="pagination">
      <li
        v-if="current !== 1"
        class="page-item">
        <a
          @click.prevent="$emit('handlePagination', (current - 1))"
          href="#"
          aria-label="Previous"
          class="page-link">
          <i class="fa fa-angle-double-left"></i>
        </a>
      </li>
      <li
        v-for="page in pages"
        :key="`page-number-${page}`"
        :class="{ 'active': page === current }"
        class="page-item">
        <a
          @click.prevent="$emit('handlePagination', page)"
          class="page-link"
          href="#">{{ page }}</a>
      </li>
      <li
        v-if="current !== pages"
        class="page-item">
        <a
          @click.prevent="$emit('handlePagination', (current + 1))"
          href="#"
          aria-label="Next"
          class="page-link">
          <i class="fa fa-angle-double-right"></i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: [
    'pages',
    'current'
  ]
};
</script>

<style scoped lang="scss">
@import '@/scss/components/ui/ListPagination';
</style>
